export const UPDATE_PREFERENCE = 'UPDATE_PREFERENCE';

export const updatePreference = payload => ({
  type: UPDATE_PREFERENCE,
  payload,
});
